module.exports = __webpack_public_path__ + "img/37855-075_crop.75599ddf.jpg";